import { ContractType } from '../types'

export const getContractsBySupplier = (supplierId) => {
  return `{
    contractsBySupplier(supplierId: ${supplierId}) ${ContractType}
  }`
}
